'use strict';

const truncate = ({ size, indicator }) => (text) => text.length <= size ? text : `${text.slice(0, size - indicator.length)}${indicator}`;
const isString = (value) => typeof value === 'string';
const classNames = (...classes) => classes.filter(Boolean).join(' ');

exports.classNames = classNames;
exports.isString = isString;
exports.truncate = truncate;
//# sourceMappingURL=text.js.map
